module.exports = __webpack_public_path__ + "img/play-detail.a6fcfe5b.png";